import { useSelector } from 'react-redux';
import { MrnConfig } from '../common/types/Projects';
import { projectPickerSelectors } from '../redux/modules/projectPicker';

export const useActiveMrnConfig = (): MrnConfig =>
  useSelector(state => projectPickerSelectors.selectActiveMrnConfig(state));
